export default "__VITE_ASSET__B9Wmv_fu__"